import React from "react";

import { useTranslation } from "react-i18next";
import BaseActionButton from "./BaseActionButton";

const EditButton = ({
    hide,
    onClick,
    disabled,
    className,
    tippy,
    tippySettings,
}) => {
    const { t } = useTranslation();

    return (
        <BaseActionButton
            className={`table-btn table-btn-blue ${className || ""}`}
            hide={hide}
            onClick={onClick}
            disabled={disabled}
            icon={"fas fa-tools"}
            tippySettings={
                tippy
                    ? {
                          content: t("edit"),
                      }
                    : tippySettings
            }
        />
    );
};

export default EditButton;
